import {isPendingHl7Import, patientContact} from '@/modules/patients/functions'
import {Box, Button} from '@chakra-ui/react'
import {Patient} from '@cypro/engine/schema'
import {dialog} from '@cypro/ui/components'
import {DataList} from '@cypro/ui/components/ui/data-list'
import {DataSection} from '@cypro/ui/components/ui/data-section'
import {useCan} from '@/shared/hooks/use-permissions'
import {useTranslate} from '@tolgee/react'
import {useMemo} from 'react'
import {EmergencyContactDialog} from '../../dialogs/emergency-contact-dialog'

interface Props {
  patient: Patient
}

export function EmergencyContact({patient}: Props) {
  const {t} = useTranslate('common')
  const canEditPatient = useCan('patients.edit')

  const emergencyItems = useMemo(() => {
    const emergencyContact = patientContact(patient, 'emergency')
    return [
      {label: t('name'), value: emergencyContact?.name || '-'},
      {label: t('phone'), value: emergencyContact?.phone || '-'},
    ]
  }, [t, patient])

  return (
    <Box rounded="md" borderWidth="1px" padding="4">
      <DataSection
        label={
          <Box display="flex" flexDirection="row" justifyContent="space-between">
            {t('emergency_contact')}
            <Button
              variant="ghost"
              colorPalette="cyan"
              disabled={!canEditPatient || isPendingHl7Import(patient)}
              onClick={async () => {
                const emergency = patientContact(patient, 'emergency')
                await dialog.open('emergency-contact', {
                  children: <EmergencyContactDialog patientId={patient.id} contact={emergency} />,
                })
              }}
            >
              {t('edit')}
            </Button>
          </Box>
        }
      >
        <DataList items={emergencyItems} />
      </DataSection>
    </Box>
  )
}
